module.exports = __webpack_public_path__ + "img/i_ar_list_order_on.4dad283c.svg";